/* eslint-disable */

import React from "react"
import {languages} from './strings/generated/menus.json'
import { Provider } from "react-redux"
import { createStore } from "redux"
import reducers from "./state/reducer";
import AppWrapper from '@/layouts/AppWrapper'

export const preloadedState = {
    translatedUrls:languages,
    playlist:[],
    currentMedia:{},
    isPlaying:false,
    isAutoPlay:false,
    mpPlayPause:false,
    breadcrumb:{
        items:[],
        title:''
    }
}

import "@oscar-21/react-placeholder/lib/reactPlaceholder.css"
import "normalize.css/normalize.css"
import "./styles/reset.css"
import "./styles/tailwind-output.css"

export default ({ element }) => {
    const store = createStore(reducers, preloadedState)
    return (
        <Provider store={store}>
                <AppWrapper>
                    {element}
                </AppWrapper>
        </Provider>
    )
}
